import React, { ReactElement } from 'react';
import { Stack, SvgIcon, Typography } from '@mui/material';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';

interface TaskCardHeadingProps {
  icon: ReactElement;
  label: string;
  labelColor?: string;
  ariaLabelId?: string;
}

export const TaskCardHeading = ({ icon, label, labelColor, ariaLabelId }: TaskCardHeadingProps) => {
  const { theme } = useThemeUtils();
  return (
    <Stack className="task-card-heading" direction="row" spacing={1} alignItems="center">
      <SvgIcon aria-hidden="true" className="task-card-heading__icon" color="secondary">
        {icon}
      </SvgIcon>
      <Typography
        id={ariaLabelId}
        className="task-card-heading__task-type-label"
        variant="body1"
        color={labelColor ?? theme.palette.primary.main}
      >
        {label}
      </Typography>
    </Stack>
  );
};
